<template>
  <fieldset
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div class="field">
        <legend
          class="label RMPE-DynamicField-Label"
        >
          <span
            :class="{'RMPE-Required': question.required}"
            v-html="question.formattedLabel"
          />
        </legend>

        <HintMessage :hint="question.formattedDescription" />

        <MediaMiddlePartial :layout="layout" />

        <ul class="RMPE-DynamicCheckboxRadios">
          <li
            v-for="(option, index) in options"
            :key="option.id"
            class="RMPE-DynamicCheckboxRadio"
            :class="{'isSelected': isSelected(option.id)}"
          >
            <label
              :id="generateSafeId(fieldQuestionId, option.id, 'label')"
              :ref="index === 0 ? 'auto-focus-target' : null"
              :for="generateSafeId(fieldQuestionId, option.id)"
              tabindex="0"
              @keydown.space.prevent="fakeClickOnInput(option.id)"
            >
              <input
                :id="generateSafeId(fieldQuestionId, option.id)"
                :ref="generateSafeId(fieldQuestionId, option.id, 'ref')"
                v-model="interfaceValue"
                :checked="fieldValue === option.id"
                :value="option.id"
                type="checkbox"
              >
              <span class="RMPE-DynamicCheckboxRadio-Label">
                <kbd
                  v-if="shouldShowKeyboardHint"
                  class="RMPE-KeyboardKey"
                >
                  {{ getKeyboardKey(index) }}
                </kbd>
                <span>
                  {{ option.label }}
                </span>
              </span>
            </label>
          </li>
        </ul>
        <ErrorMessage
          :field-has-error="fieldHasError"
          :errors="error.errors"
          :is-blurred="isBlurred"
        />
        <div class="RMPE-DynamicForm-SubmitContainer">
          <button
            :disabled="isNextButtonDisabled"
            class="button is-primary RMPE-CustomSubmit"
            @click="goToNextQuestion"
          >
            {{ question.goToNextQuestionButtonLabel }}
          </button>
        </div>
      </div>
    </component>
  </fieldset>
</template>

<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import KeyboardShortcutMixin from '../../mixins/keyboard-shortcut-mixin';
import CheckboxGroupFieldMixin from '../common/checkbox-group-field';

export default {
  mixins: [DynamicFieldMixin, KeyboardShortcutMixin, CheckboxGroupFieldMixin],

  methods: {
    isSelected(id) {
      if (!Array.isArray(this.fieldValue)) return false;

      return this.fieldValue.includes(id);
    },
  },
};
</script>
